import { render, staticRenderFns } from "./AddNewCaseView.vue?vue&type=template&id=ca5be202&scoped=true"
import script from "./AddNewCaseView.vue?vue&type=script&lang=js"
export * from "./AddNewCaseView.vue?vue&type=script&lang=js"
import style0 from "./AddNewCaseView.vue?vue&type=style&index=0&id=ca5be202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5be202",
  null
  
)

export default component.exports